module.exports = __webpack_public_path__ + "img/truck_nosignal.2f565a0b.svg";